import React from 'react';
import ReactDOM from 'react-dom';
import MyComponent from './MyComponent'; // assuming MyComponent is in the same directory
import './App.css';

function App() {
  ReactDOM.render(
    <React.StrictMode>
      <MyComponent />
    </React.StrictMode>,
    document.getElementById('root')
  );
}

export default App;